import { axios } from './config';

// 公司配置-操作日志
export function getoperationLogList(params){
  return axios.post('/userlog/list_all', params, false)
}

// 公司配置-搜索日志
// export function searchOperationLogList(params) {
//   return axios.
// }

// 数据源- 获取列表
export function getDataConfigList(params) {
  return axios.get('/databackup/list_all', params, true)
}

// 数据源-创建备份
export function createDataBackup(params) {
  return axios.post('/databackup/backup', params, true)
}

// 获取角色权限列表
export function getRolePermissions(params) {
  return axios.get('/menuCopy/list_all', params, true)
}

// 获取某个角色已选择的权限
export function getHavePermission(params) {
  return axios.get('/menuCopy/getRoleMenuList', params, true)
}

// 获取角色可以操作的权限列表
export function getRoleList(params) {
  return axios.get('/menuCopy/getUserMenuTree', params, false)
}

// 获取角色列表
export function getAllRole(params) {
  return axios.get('/businessManagement/roleManagement/getRoles', params, true)
}

// 用户批量绑定角色
export function batchBindRole(params) {
  return axios.post('/businessManagement/userManagement/batchBindingRole', params, false)
}
